module.exports = __webpack_public_path__ + "img/argument-3.73779999.jpg";